import { generateImageKitURL } from '@/lib/generate-imagekit-url'

import type { Transformation } from '@/types/imagekit'

type SimpleImageProps = {
  path: string
  alt?: string
  width?: string
  height?: string
  transforms: Transformation
  className?: string
}

export default function SimpleImage({
  path,
  alt = '',
  width,
  height,
  transforms,
  className = '',
}: SimpleImageProps) {
  return (
    <img
      src={generateImageKitURL(path, transforms)}
      width={width || ''}
      height={height || ''}
      alt={alt}
      className={className}
    />
  )
}
